import Header from "./Header";
import Footer from "./footer";

const ContactUs = () => {
  
    return (
      <div>
      <Header />
      <div className="mizuki1">
        <span className="ipsum"><i className="fa-solid fa-left-long"></i></span>
        <h1>Contact Us</h1>
    </div>

    <div className="bredcrub">
        <div className="container">
            <ul>
                <li><a href="#">Home</a> <i className="fa-solid fa-angle-right"></i></li>
                <li>Contact Us</li>
            </ul>
        </div>
    </div>

    <div className="contactarea">
        <div className="container">
            <div className="row">
                <div className="col-md-6 col-sm-6 col-xs-12">
                    <div className="row">
                        <div className="maparea1">
                            {/* <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3557.355535752536!2d75.82455511452088!3d26.92394106608939!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x396db14b1bd30ba5%3A0x860e5d531eccb20c!2sHawa%20Mahal!5e0!3m2!1sen!2sin!4v1669138619885!5m2!1sen!2sin" width="550" height="400" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe> */}
                        </div>
                        <div className="conform">
                            <div className="condata">
                                <h2>Hello</h2>
                                <p>Anything you’d like us to know?</p>

                                <form action="#" className="form-group">
                                    <input type="text" placeholder="Name*" className="passwordbox innerwidthset" />
                                    <input type="tel" placeholder="Mobile Number*" className="passwordbox innerwidthset" />
                                    <input type="email" placeholder="Email*" className="passwordbox innerwidthset" />
                                    <textarea placeholder="Message*" className="passwordbox innerwidthset bigtext"></textarea>
                                    <button>Send Message</button>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="col-md-6 col-sm-6 col-xs-12">
                    <div className="row">
                        <div className="maparea">
                            {/* <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3557.355535752536!2d75.82455511452088!3d26.92394106608939!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x396db14b1bd30ba5%3A0x860e5d531eccb20c!2sHawa%20Mahal!5e0!3m2!1sen!2sin!4v1669138619885!5m2!1sen!2sin" width="550" height="400" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe> */}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <footer className="contactfoot">
        <div className="container">
            <div className="row">
                <ul>
                    <li className="head1"><i className="fa-solid fa-at"></i> <span>care@zeonutra.com</span></li>
                    <li className="head2"><i className="fa-solid fa-phone"></i> <span>(+91) 00000 00000</span></li>
                    <li className="head3"><i className="fa-solid fa-location-dot"></i> <span>ZeoNutra (Head office) B Block, Sector 65, Noida, Uttar Pradesh 201307</span></li>
                </ul>
            </div>
        </div>
    </footer>

    <div className="ruled">
        <div className="speci">
            <div className="icon1">
                <div className="facebook"> <i className="fa-brands fa-facebook-f"></i></div>
                <div className="twitter"><i className="fa-brands fa-twitter"></i></div>
                <div className="instagram"><i className="fa-brands fa-instagram"></i></div>
                <div className="pinterest"><i className="fa-brands fa-pinterest-p"></i></div>
                <div className="youtube"><i className="fa-brands fa-youtube"></i></div>
                <div className="linkedin"><i className="fa-brands fa-linkedin-in"></i></div>
            </div>
        </div>

        <section>
            <div className="container">
                <div className="kout">
                    <div className="chec">
                    <img src="/images/Vector1.png" alt=""/> 
                        <h3>Try us at a special price, use code on checkout.</h3>
                        <div className="good">
                            <h2>GOODHEALTH <i className="fa-solid fa-file"></i></h2>
                        </div>
                    </div>
                    <div className="speci">
                        <div className="join">
                        <div className="row">
                            <div className="col-md-7">
                            <div className="space">
                                <h3>Stay tuned with us for health tips, product information and New Launches.</h3>
                                <button><i className="fa-regular fa-envelope"></i> JOIN OUR NEWSLETTER</button>
                            </div>
                            </div>
                            <div className="col-md-5">
                            <div className="ellipse">
                                <img src="/images/Capture.PNG" alt=""/>
                            </div>
                            </div>
                        </div>
                        </div>
                        <div className="icon">
                        <div className="facebook"> <i className="fa-brands fa-facebook-f"></i></div>
                        <div className="twitter"><i className="fa-brands fa-twitter"></i></div>
                        <div className="instagram"><i className="fa-brands fa-instagram"></i></div>
                        <div className="pinterest"><i className="fa-brands fa-pinterest-p"></i></div>
                        <div className="youtube"><i className="fa-brands fa-youtube"></i></div>
                        <div className="linkedin"><i className="fa-brands fa-linkedin-in"></i></div>
                        </div>
                    </div>
                    <div className="chec1">
                    <img src="/images/Vector1.png" alt=""/> 
                        <h3>Try us at a special price, use code on checkout.</h3>
                        <div className="good">
                            <h2>GOODHEALTH <i className="fa-solid fa-file"></i></h2>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        
        <footer>
            <div className="footer">
                <div className="nutra">
                    <h6>ZeoNutra</h6>
                    <p>Contact Us</p>
                    <p>Blogs</p>
                    <p>Press</p>
                    <p>FAQs</p>
                    <p>My Account</p>
                    <p>Site Map</p>
                </div>
                <div className="nutra">
                    <h6>Why ZeoNutra?</h6>
                    <p>Our Mission</p>
                    <p>Our Ingredients</p>
                    <p>Our Experts</p>
                    <p>About Us</p>
                </div>
                <div className="nutra">
                    <h6>Also available on</h6>
                    <p>Amazon</p>
                    <p>Dhani</p>
                    <p>First Cry</p>
                    <p>Flipkart</p>
                    <p>Healthkart</p>
                    <p>Local Options</p>
                    <p>Meesho</p>
                    <p>Netmeds</p>
                    <p>Pharmacy</p>
                    <p>Pharmeasy</p>
                    <p>Tata 1mg</p>
                </div>
            </div>
        </footer>
            <div className="paytmcard1">
                <img src="/images/Paytm.png" alt=""/>
                <img src="/images/GPay.png" alt=""/>
                <img src="/images/GPay 1.png" alt=""/>
                <img src="/images/GPay 2.png" alt=""/>
                <img src="/images/GPay 3.png" alt=""/>
                <img src="/images/GPay 4.png" alt=""/>
                <img src="/images/GPay 5.png" alt=""/>
                <img src="/images/GPay 6.png" alt=""/>
                <img src="/images/GPay 7.png" alt=""/>
            </div>
        <div className="zeon">
            <div className="container">
                <div className="row">
                    <div className="col-md-6">
                        <h5 className="global1">© Zeon Global Nutritions Pvt. Ltd.</h5>
                        <h5 className="global">ZeoNutra by Zeon Global Nutritions Pvt. Ltd. ©</h5>
                    </div>
                    <div className="col-md-6">
                        <div className="policy">
                            <a href="#">Privacy Policy</a>
                            <a href="#">Terms of Services</a>
                            <a href="#" className="refund-Policy">Refund Policy</a>
                            <a href="#" className="refund-Policy">Shipping Policy</a>
                            <a href="#" className="refund-Policy">Pricing Policy</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    </div>
    );
  };
  
export default ContactUs;